$(document).ready(function () {
// ***** Front Page Sliders ***** //

/* Default Slide 01 - ICEBERG */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_YBEk7V .swiper-slide[aria-label="1 / 3"]').on('click', function() {
    window.location.href = '/collections/iceberg';
  });
  
/* Default Slide 02 - WAKEY */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_YBEk7V  .swiper-slide[aria-label="2 / 3"]').on('click', function() {
    window.location.href = '/collections/wake';
  });
  
/* Default Slide 03 - CUBA */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_YBEk7V  .swiper-slide[aria-label="3 / 3"]').on('click', function() {
    window.location.href = '/collections/cuba';
  });
  
/* NL Slide 01 - WAKEY */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_yFXKGq .swiper-slide[aria-label="1 / 3"]').on('click', function() {
    window.location.href = '/collections/wake';
  });
  
/* NL Slide 02 - ZERONITO */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_yFXKGq .swiper-slide[aria-label="2 / 3"]').on('click', function() {
    window.location.href = '/collections/zeronito';
  });
  
/* NL Slide 03 - R4VE */
  $('body.page-index #shopify-section-template--25223551517058__slideshow_yFXKGq .swiper-slide[aria-label="3 / 3"]').on('click', function() {
    window.location.href = '/collections/r4ve';
  });

});

$(document).ready(function () {
//***** frontpage: change "see more URL of the top 'featured collection' block *****//
$('body.page-index .pouches24_featured_collection_block .section-head-top a.link.underlined-link').attr('href' , '/collections/all-products');


// collections: Remove the 'checked' attr from hidden '1pc' variant + click to select the 10pc OR 10pcs variant
  function collectionPages_makeTenPieceVariantTheDefault() {
    const pouches24_productCollection_selector = 
'body.page-collection .collection .card_pro_details .js.product-form__input input:radio, body.page-index .pouches24_category_product_block .collection .card_pro_details .js.product-form__input input:radio,  body.page-index .pouches24_featured_collection_block .collection .card_pro_details .js.product-form__input input:radio';
  
    // Uncheck '1 pc'
    $(pouches24_productCollection_selector)
      .filter('[value="1 pc"]')
      .each(function () {
        $(this).removeAttr('checked'); // Uncheck 1pc variant
        $(this).next('label').addClass('p24_hide_1pc_variant'); // Hide the wrapping label
      });

  
    // Check '10pc' OR '10pcs'
    $(pouches24_productCollection_selector)
      .filter(function() {
        return $(this).val().match(/^10\s?pcs?$/);
      })
      .each(function () {
        $(this).click();
      });
  //console.log("10pcs variant in 'Collection' selected on pageLoad.");

  }

// Execute the function on page load
    collectionPages_makeTenPieceVariantTheDefault();

// Select the product grid container
    const productGridContainer = document.querySelector('.product-grid-container');

    if (productGridContainer) {
        // MutationObserver to listen for changes
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    //console.log("Product grid container updated.");
                    collectionPages_makeTenPieceVariantTheDefault(); // Run the custom logic whenever the grid updates
                    break; // Avoid multiple triggers
                }
            }
        });

// Start observing the container for changes (filter selections, toggles etc. that change the content of the element)
        observer.observe(productGridContainer, {
            childList: true, // Watch for added/removed child elements
            subtree: false, // Only monitor direct children
        });
    } else {
        //console.error("Product grid container not found.");
    }

//***** disable 1pc variant & select 10pc/10pcs: QuickAdd Modals *****//

// Set the 10pc OR 10pcs variant as default in the Quick Add modal
    function quickAddModal_makeTenPieceVariantTheDefault(modal) {
        $(modal).find('.js.product-form__input input:radio').filter('[value="1 pc"]').removeAttr('checked');
        $(modal).find('.js.product-form__input input:radio').filter(function() {
            return $(this).val().match(/^10\s?pcs?$/);
          })
          .each(function () {
            $(this).click();
          });

        //console.log("10pc OR 10pcs variant in 'Quick Add Modal' selected.");
    }

// MutationObserver to monitor Quick Add modals for the 'open' attribute
    const quickAddObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'open' &&
                $(mutation.target).hasClass('quick-add-modal') &&
                $(mutation.target).attr('open') !== undefined // Check if 'open' is present
            ) {
                //console.log("Quick Add modal opened. Applying default selection.");
                quickAddModal_makeTenPieceVariantTheDefault(mutation.target); // Pass the modal element to the function
            }
        });
    });

// Start observing the body for attribute changes in 'quick-add-modal' elements
    document.querySelectorAll('.quick-add-modal').forEach((modal) => {
        quickAddObserver.observe(modal, { attributes: true });
    });

// Dynamically handle new modals added to the DOM (optional, if modals are dynamically injected)
    const bodyObserver = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            if (mutation.type === 'childList') {
                $(mutation.addedNodes).each(function () {
                    if ($(this).hasClass('quick-add-modal')) {
                        //console.log("New Quick Add modal detected. Observing for 'open' attribute.");
                        quickAddObserver.observe(this, { attributes: true });
                    }
                });
            }
        });
    });

// Start observing the body for new modals being added
    bodyObserver.observe(document.body, { childList: true, subtree: true });

//***** disable 1pc variant & select 10pc/10pcs: Single Product Page *****//
// single product pages: remove 'checked' attr from '1pc' variant + select 10pcs
    function singleProductPages_makeTenPieceVariantTheDefault() {
      const pouches24_singleProductPage_selector = 'body.page-product .js.product-form__input input:radio';
  
      // Uncheck '1 pc'
      $(pouches24_singleProductPage_selector).filter('[value="1 pc"]').removeAttr('checked');
    
      // Check '10pc' OR '10pcs'
      $(pouches24_singleProductPage_selector)
          .filter(function() {
            return $(this).val().match(/^10\s?pcs?$/);
          })
          .each(function () {
            $(this).click();
          });
      //console.log("10pcs variant in 'Single Product Page' selected on pageLoad.");
    }

// Execute the function on page load
    singleProductPages_makeTenPieceVariantTheDefault();
});

$(document).ready(function () {
// featured product blocks: remove 'checked' attr from '1pc' variant + select 10pcs
  function featuredProductBlock_makeTenPieceVariantTheDefault() {
    const pouches24_featuredProductBlock_selector = 'body.page-index section.section-featured-product .js.product-form__input input:radio';
    
      // Uncheck '1 pc'
      $(pouches24_featuredProductBlock_selector).filter('[value="1 pc"]').removeAttr('checked');
      
      // Check '10pc' OR '10pcs'
      $(pouches24_featuredProductBlock_selector)
          .filter(function() {
            return $(this).val().match(/^10\s?pcs?$/);
          })
          .each(function () {
            $(this).click();
          });
    //console.log("10pcs variant in 'Featured Product Block' selected on pageLoad.");
    }
  
  // Execute the function on page load
      featuredProductBlock_makeTenPieceVariantTheDefault();

});

$(document).ready(function () {
//***** Shopping Cart Page: Single Item Calculator *****//
    if ($('body').hasClass('page-cart')) {
        function calculateTotalSinglePieces() {
            let totalSinglePieces = 0;

            // Loop through all cart items
            $('.cart-item').each(function () {
                const quantityText = $(this).find('dd').text().trim(); // Get the "10 pc" or "240 pc"
                const quantityInput = $(this).find('.quantity__input'); // Reference the quantity input element
                const itemQuantity = parseInt(quantityInput.val(), 10); // Get the quantity value

                // Parse the quantity multiplier (10 or 240) from the text
                const multiplier = parseInt(quantityText.replace('pc', '').trim(), 10);

                // Ensure we only calculate with valid quantities (minimum enforced by Shopify)
                if (!isNaN(multiplier) && !isNaN(itemQuantity) && itemQuantity > 0) {
                    totalSinglePieces += multiplier * itemQuantity; // Add to total
                }
            });

            // Update the counter
            $('#single_pieces_dynamic_counter').text(totalSinglePieces);
        }

        // Initial calculation when the page loads
        calculateTotalSinglePieces();

        // Observe quantity changes (input change or +/- button click)
        $(document).on('input change', '.quantity__input', function () {
            const inputElement = $(this);

            // Wait for Shopify to enforce the quantity constraint
            setTimeout(() => {
                if (parseInt(inputElement.val(), 10) > 0) {
                    calculateTotalSinglePieces();
                }
            }, 50); // Adjust the delay if necessary for Shopify's behavior
        });

        // Observe item removal (cart-item removal)
        $(document).on('click', '.cart-remove-button a', function (e) {
            // Wait for the item to be removed and then recalculate
            setTimeout(calculateTotalSinglePieces, 500);
        });

        // Monitor DOM changes using MutationObserver for added reliability
        const cartObserver = new MutationObserver(() => {
            calculateTotalSinglePieces();
        });

        const cartElement = document.querySelector('.cart__contents');
        if (cartElement) {
            cartObserver.observe(cartElement, { childList: true, subtree: true });
        }
    }
});
